module.exports = __webpack_public_path__ + "img/photo_2022-11-09_18-32-28.7acb1294.jpg";